export default {
  partners: {
    title: 'Report "Partners"',
    subtitle: 'System data as of %{responseTime}',
    alias: 'Account Alias',
    number: 'Account Number',
    postedAmount: 'Posted Amount',
    noAccounts: 'No active accounts',
    noPartners: 'No active partners',
  },
  tenantAccounts: {
    title: 'Report "Tenant Accounts"',
    subtitle: 'System data as of %{responseTime}',
    alias: 'Account Alias',
    number: 'Account Number',
    postedAmount: 'Posted Amount',
    noAccounts: 'No active accounts',
    unknownProduct: 'Unknown Product',
  },
};
